import { render, staticRenderFns } from "./TheButton.vue?vue&type=template&id=6ca73928&scoped=true&"
import script from "./TheButton.vue?vue&type=script&lang=js&"
export * from "./TheButton.vue?vue&type=script&lang=js&"
import style0 from "./TheButton.vue?vue&type=style&index=0&id=6ca73928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca73928",
  null
  
)

export default component.exports